var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.937,
    height: 43.91,
    viewBox: "0 0 42.937 43.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    transform: "translate(-5.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    transform: "translate(5.411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M122.506,259.238a1,1,0,0,0-1-1h-3.478a1,1,0,0,0-1,1v3.478a1,1,0,0,0,1,1h3.478a1,1,0,0,0,1-1v-3.478Z",
    transform: "translate(-106.994 -235.013)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M219.14,259.238a1,1,0,0,0-1-1h-3.478a1,1,0,0,0-1,1v3.478a1,1,0,0,0,1,1h3.478a1,1,0,0,0,1-1Z",
    transform: "translate(-194.937 -235.013)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M315.769,259.238a1,1,0,0,0-1-1h-3.478a1,1,0,0,0-1,1v3.478a1,1,0,0,0,1,1h3.478a1,1,0,0,0,1-1Z",
    transform: "translate(-282.873 -235.013)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M122.506,355.871a1,1,0,0,0-1-1h-3.478a1,1,0,0,0-1,1v3.477a1,1,0,0,0,1,1h3.478a1,1,0,0,0,1-1v-3.477Z",
    transform: "translate(-106.994 -322.953)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M219.14,355.871a1,1,0,0,0-1-1h-3.478a1,1,0,0,0-1,1v3.477a1,1,0,0,0,1,1h3.478a1,1,0,0,0,1-1Z",
    transform: "translate(-194.937 -322.953)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M315.769,355.871a1,1,0,0,0-1-1h-3.478a1,1,0,0,0-1,1v3.477a1,1,0,0,0,1,1h3.478a1,1,0,0,0,1-1v-3.477Z",
    transform: "translate(-282.873 -322.953)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M44.526,54.161v5.312a4.338,4.338,0,0,1-4.348,4.336H37.435a4.361,4.361,0,0,1-4.374-4.336V54.142H20.7v5.331a4.36,4.36,0,0,1-4.374,4.336H13.581a4.338,4.338,0,0,1-4.348-4.336V54.161a3.954,3.954,0,0,0-3.822,3.933V89.223a3.956,3.956,0,0,0,3.936,3.959H44.412a3.96,3.96,0,0,0,3.936-3.959V58.094A3.954,3.954,0,0,0,44.526,54.161ZM43.252,87.285a1.7,1.7,0,0,1-1.7,1.7H12.133a1.7,1.7,0,0,1-1.7-1.7V71.205a1.7,1.7,0,0,1,1.7-1.7H41.55a1.7,1.7,0,0,1,1.7,1.7V87.285Z",
    transform: "translate(-5.411 -49.272)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M81.041,11.689h2.713a1.49,1.49,0,0,0,1.491-1.49V1.491A1.491,1.491,0,0,0,83.754,0H81.041A1.491,1.491,0,0,0,79.55,1.491V10.2A1.49,1.49,0,0,0,81.041,11.689Z",
    transform: "translate(-72.881)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M345.949,11.689h2.713a1.49,1.49,0,0,0,1.491-1.49V1.491A1.491,1.491,0,0,0,348.662,0h-2.713a1.491,1.491,0,0,0-1.491,1.491V10.2A1.49,1.49,0,0,0,345.949,11.689Z",
    transform: "translate(-313.96)",
    fill: "#212968"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1a6abeb75c9ea59213c3c56584e73ce3.svg";
export { ForwardRef as ReactComponent };